<script>
  import { onMount, createEventDispatcher } from "svelte";
  import objectStore from "./store.js";

  const dispatch = createEventDispatcher();
  let plans = [];
  export let api;

  onMount(async () => {
    // Simulación local de respuesta de la API
    // const mockPlansData = [
    //   {
    //     creditPlanId: 146,
    //     creditTypeId: 9,
    //     credits: 0,
    //     price: 14.99,
    //     title: "Domain",
    //     description: "1 Year Subscription",
    //     active: true,
    //     recurring: true,
    //     dateCreated: "2024-03-04T19:58:43.227",
    //     dateModified: "2024-03-04T19:58:43.227",
    //     periodId: 5,
    //     updateCredits: false,
    //     periodFrequency: 1,
    //     requests: 0,
    //     creditType: null,
    //     period: null,
    //     creditPayments: [],
    //     creditSubscriptions: [],
    //   },
    //   {
    //     creditPlanId: 147,
    //     creditTypeId: 10,
    //     credits: 0,
    //     price: 27.99,
    //     title: "Domain",
    //     description: "2 Year Subscription",
    //     active: true,
    //     recurring: true,
    //     dateCreated: "2024-03-04T19:58:43.23",
    //     dateModified: "2024-03-12T08:15:48.273",
    //     periodId: 5,
    //     updateCredits: false,
    //     periodFrequency: 2,
    //     requests: 0,
    //     creditType: null,
    //     period: null,
    //     creditPayments: [],
    //     creditSubscriptions: [],
    //   },
    //   {
    //     creditPlanId: 148,
    //     creditTypeId: 10,
    //     credits: 0,
    //     price: 37.99,
    //     title: "Domain",
    //     description: "3 Year Subscription",
    //     active: true,
    //     recurring: true,
    //     dateCreated: "2024-03-04T19:58:43.233",
    //     dateModified: "2024-03-12T08:15:48.273",
    //     periodId: 5,
    //     updateCredits: false,
    //     periodFrequency: 3,
    //     requests: 0,
    //     creditType: null,
    //     period: null,
    //     creditPayments: [],
    //     creditSubscriptions: [],
    //   },
    // ];

    try {
      // const responseDomains = mockPlansData;
      const response = await fetch(api + "domains/DomainsPlans");
      let data = await response.json();
      plans = data.map((plan) => ({
        id: plan.creditPlanId,
        name: plan.description,
        price: `$${plan.price} USD`,
        h: false,
        a: false,
      }));
    } catch (error) {
      console.error("Error fetching domains plans:", error);
    }
  });

  function handlePlan(plan) {
    objectStore.updateItem({
      available: true,
      back: false,
      sub: $objectStore.sub,
      domain: $objectStore.domain,
      plan: plan,
    });

    dispatch("planset", {
      plan: plan,
    });
  }
</script>

<div class="content">
  <h1 style="margin-bottom: 0; padding-top: 15px !important;">Choose a Plan</h1>
  <h4 class="subtitle" style="color: #676767; font-weight: 400; margin-top: 0;">
    for {$objectStore.sub || ""}{$objectStore.domain || ""}
  </h4>

  {#each plans as plan}
    <div
      class="plan ripple-plan {$objectStore.plan &&
      plan.id === $objectStore.plan.id
        ? 'high-light'
        : ''}"
      on:click={() => handlePlan(plan)}
      on:mouseenter={() => (plan.h = true)}
      on:mouseleave={() => (plan.h = false)}
      on:tap={() => (plan.a = true)}
    >
      <div class="radio {plan.a ? 'active' : ''}">
        <span
          class="circle {$objectStore.plan && plan.id === $objectStore.plan.id
            ? 'hover'
            : ''} {plan.h ? 'hover' : ''}"
        ></span>
      </div>
      <div class="info">
        <div class="name">{plan.name}</div>
        <div class="price">{plan.price}</div>
      </div>
    </div>
  {/each}
</div>

<style>
  .content {
    padding: 0 16px;
    text-align: start !important;
  }
  .plan {
    display: flex;
    align-items: flex-start;
    gap: 12px;
    padding: 8px 0; /* <-- antes: 12px 16px */
    width: 100%;
    border: none;
    max-width: 600px;
    border-radius: 10px;
    margin: 0 0 8px 0;

    /* margin: 0 auto 12px auto; control más fino abajo */
    cursor: pointer;
    background-color: transparent;
    flex-direction: row;
    transition: border 0.3s ease;
  }

  .plan.high-light {
    /* outline: 2px solid #007aff; */
    outline-offset: 2px;
  }

  .radio {
    height: 24px;
    width: 24px;
    background-color: #fff;
    border: 2px solid #007aff;
    border-radius: 50%;
    flex-shrink: 0;
  }
  .radio .circle {
    display: block;
    opacity: 0;
    background-color: #007aff;
    border-radius: 50%;
    height: 18px;
    width: 18px;
    margin: 3px;
    transition: opacity 250ms ease-in-out;
  }
  .circle.hover {
    opacity: 0.5;
  }

  .radio.active .circle,
  .plan:active .circle,
  .plan:focus .circle {
    opacity: 1;
  }

  .info {
    display: flex;
    flex-direction: column;
    margin-left: 8px;
  }

  .name {
    font-size: 18px;
    font-weight: 700;
    color: #111;
    line-height: 1.2;
    margin-bottom: 4px;
  }

  .price {
    font-size: 16px;
    color: #444;
    margin-top: 0;
  }

  h4.subtitle {
    text-align: left;
    color: #676767;
    font-weight: 400 !important;
    margin-top: 0;
    margin-bottom: 24px;
  }

  @media (min-width: 640px) {
    .plan {
      flex-direction: row;
      align-items: center;
      margin-bottom: 8px;
    }

    .info {
      flex-direction: row;
      gap: 12px;
      align-items: center;
    }

    .name {
      margin-bottom: 0;
    }

    .price {
      margin-top: 0;
      text-align: start !important;
    }
  }
</style>
